function FilterIcon(props) {
  return (
    <svg id='FilterIcon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14.877 15.976' {...props}>
      <path
        id='Tracciato_71'
        data-name='Tracciato 71'
        d='M762.716-983.975l4.625,5.234v5.112l3.773,3.9v-8.277l4.382-5.964Z'
        transform='translate(-761.607 984.475)'
        fill='none'
        stroke={props.color ? props.color : '#000000'}
        strokeWidth='1'
      />
    </svg>
  )
}

export default FilterIcon
